import type { FormEventHandler, PropsWithChildren, ReactNode } from "react";

import { Layout } from "@/shared/ui";

type QuestionStepProps = PropsWithChildren & {
  /** Footer node, typically a <QuestionNavigation /> rendering a sticky Layout.Footer. */
  footer: ReactNode;
  onSubmit?: FormEventHandler<HTMLFormElement>;
  size?: "sm";
};

/**
 * Layout wrapper for a questionnaire step. The content area scrolls while the
 * footer (navigation) stays pinned to the bottom of the viewport, so the
 * advance button is always visible without scrolling.
 */
export const QuestionStep = ({
  children,
  footer,
  onSubmit,
  size,
}: QuestionStepProps) => (
  <form
    className="flex min-h-0 grow flex-col"
    onSubmit={(event) => {
      // Always prevent native submission (which would reload the page). Our
      // submit handlers navigate via react-router / react-hook-form instead.
      event.preventDefault();
      onSubmit?.(event);
    }}
  >
    <Layout.Content size={size}>{children}</Layout.Content>
    {footer}
  </form>
);
